module.exports = __webpack_public_path__ + "static/img/act-cx.5de70e28.png";